<div id="appointmentRescheduling" class="modal-overlay active">
  <div class="modal-panel white">
    <div id="modal-header" class="modal-header">
      <h1>
        <span class="status-modal-left">{{ 'agent:popin.reschedule_appointment.title' | translate }}</span>
      </h1>
      <button class="close-modal animate-hide" (click)="cancel()">
        <span class="nodisplay"
          >{{ 'commons:basic.closePopup' | translate }}"{{ 'agent:popin.reschedule_appointment.title' | translate }}"</span
        >
      </button>
    </div>
    <div id="modal-body" class="modal-body" *ngIf="initDone">
      <div *ngIf="hasParamsError" class="error">
        {{ 'agent:popin.reschedule_appointment.params_error' | translate }}
      </div>
      <!-- TIME SLOT SELECTOR -->
      <div id="timeSlotSelectorForm" *ngIf="!hasParamsError">
        <div id="reschedulingTip">{{ 'agent:popin.reschedule_appointment.comment_tip' | translate }}</div>
        <ng-container *ngIf="{ availableTimeSlots: availableTimeSlots$ | async } as data">
          <cng-time-slot-selector
            *ngIf="canPrintCalendar(data.availableTimeSlots)"
            [availableTimeSlots]="data.availableTimeSlots"
            [initialSelectedTimeSlot]="originalTimeSlot"
            (timeSlotUpdated)="onTimeSlotSelected($event)"
          >
          </cng-time-slot-selector>
        </ng-container>
        <fieldset>
          <legend>{{ 'agent:popin.reschedule_appointment.comment' | translate }}*</legend>
          <div id="reschedulingComment">
            <textarea [formControl]="comment"> </textarea>
          </div>
        </fieldset>
      </div>
    </div>
    <div class="modal-footer modal-confirm">
      <button [disabled]="!formIsValid()" (click)="submitForm()" class="button-confirm cng-ico_check">
        {{ 'agent:actions.validate' | translate }}
        <span class="nodisplay">
          {{ 'agent:popin.reschedule_appointment.reschedule' | translate }}
        </span>
      </button>
      <button (click)="cancel()" class="button-cancel cng-ico_annuler">
        {{ 'agent:actions.cancel' | translate }}
        <span class="nodisplay">
          {{ 'agent:popin.reschedule_appointment.reschedule' | translate }}
        </span>
      </button>
    </div>
  </div>
</div>
